import { BaseModalV2 } from 'components/ui/BaseModal'
import React, { useRef } from 'react'
import useLocaleText from 'components/useLocaleText'
import { ModalHeader } from '../commonUI/Modal/ModalHeader'
import { ModalFooter } from '../commonUI/Modal/ModalFooter'
import { CompaignForm } from './CompaignForm'

export interface CompaignFormValues {
  campaign_type: number
  root_group_id: string | null
  tag_id?: string | null
}
interface CompaignModalProps {
  isOpen: boolean
  onClose: () => void
  onRequestClose: () => void
  onCreated: (data: CompaignFormValues) => void
  campaign?: CompaignFormValues | null
}
const CompaignModal = ({ isOpen, onClose, onRequestClose, onCreated, campaign }: CompaignModalProps) => {
  const modal_title = useLocaleText('create_campaign', true)
  const admin_submit_button = useLocaleText('admin_submit_button')

  const formRef = useRef<{ submit: () => void }>(null)

  const handleSubmitClick = () => {
    formRef.current?.submit()
  }

  return (
    <BaseModalV2
      isOpen={isOpen}
      onClose={onClose}
      header={<ModalHeader title={modal_title} onClose={onRequestClose} />}
      body={<CompaignForm ref={formRef} onClose={onClose} onCreated={onCreated} campaign={campaign} />}
      footer={<ModalFooter isLoading={false} onSubmit={handleSubmitClick} buttonText={admin_submit_button} />}
      modalContentProps={{
        w: '100%',
        maxW: { base: '90vw', md: '80vw', lg: '800px' },
        minW: '350px',
      }}
      modalBodyProps={{
        height: 'auto',
        minH: '50vh',
        maxH: { base: '80dvh', md: '70dvh' },
      }}
      modalHeaderProps={{ boxShadow: 'none' }}
    />
  )
}

export default CompaignModal
